import { GDFPalletCode } from '../../../gdf/type';
import palettes from '../../../palettes/palettes';
import { generateColorExpressionFromPalette } from '../../../utils/ramp';
import { StyleFactory } from '../styling';

export const fcaLayers: StyleFactory = (baseId) => {
    const colors = generateColorExpressionFromPalette(palettes[GDFPalletCode.fca], ['get', 'color']);
    return [
        {
            id: baseId + '-poly-lines-fea',
            type: 'line',
            source: baseId,
            pickable: true,
            filter: ['==', ['get', 'type'], 1],
            layout: {
                'line-join': 'bevel'
            },
            paint: {
                'line-width': 2,
                // prettier-ignore
                'line-color': colors,
                'line-dasharray': [3, 1]
            }
        },
        {
            id: baseId + '-poly-lines-fca',
            type: 'line',
            source: baseId,
            pickable: true,
            filter: ['==', ['get', 'type'], 0],
            layout: {
                'line-join': 'bevel'
            },
            paint: {
                'line-width': 2,
                'line-color': colors,
                'line-dasharray': [1, 0]
            }
        },
        {
            id: baseId + '-poly-hover',
            type: 'fill',
            source: baseId,
            filter: ['any', ['==', ['get', 'shape'], 1], ['==', ['get', 'shape'], 3]],
            paint: {
                'fill-color': ['case', ['boolean', ['feature-state', 'hover'], false], 'rgba(0,0,0,0.22)', 'rgba(0,0,0,0)']
            }
        },
        {
            id: baseId + '-poly-context-menu',
            type: 'fill',
            source: baseId,
            filter: ['any', ['==', ['get', 'shape'], 1], ['==', ['get', 'shape'], 3]],
            paint: {
                'fill-color': 'rgba(0,0,0,0)'
            }
        },
        {
            id: baseId + '-poly-text',
            type: 'symbol',
            source: baseId,
            minzoom: 4,
            layout: {
                'text-field': ['get', 'label'],
                'text-offset': [0, 0],
                'text-allow-overlap': true,
                'text-anchor': 'top',
                'text-font': ['Open Sans Regular'],
                'text-size': 10,
                'symbol-placement': 'line'
            },
            paint: {
                'text-color': ['global-state', 'text-color']
            }
        },
        {
            id: baseId + '-airport',
            type: 'circle',
            pickable: true,
            source: baseId,
            filter: ['==', ['get', 'shape'], 4],
            paint: {
                'circle-radius': 5,
                'circle-opacity': 0,
                'circle-stroke-width': 2,
                'circle-stroke-color': colors
            }
        },
        {
            id: baseId + '-airport-text',
            type: 'symbol',
            pickable: true,
            source: baseId,
            filter: ['==', ['get', 'shape'], 4],
            minzoom: 4,
            layout: {
                'text-field': ['get', 'label'],
                'text-offset': [1.1, 0],
                'text-allow-overlap': true,
                'text-anchor': 'left',
                'text-font': ['Open Sans Regular'],
                'text-size': 10
            },
            paint: {
                'text-color': ['global-state', 'text-color']
            }
        }
    ];
};
